import { formatDate, listToString } from "../../Layers/fields/formatters";
import { getCycleStartCommand, getRipeningProgramDisplayValue } from "./ripeningProgramCycle";

// * config.get_form_option_label: the option's label, or the value itself when no option matches.
export type GetFormOptionLabel = (field: string, value: any) => any;

const CYCLE_START_STATUS_TEXT: Record<string, string> = {
    pending: "Sent to the ripening room",
    accepted: "Started by the ripening room",
    rejected: "Not started by the ripening room",
    timeout: "No answer from the ripening room",
};

// * meta.controller_command: the program start command sent to the ripening room, shown as its
// * status plus the room's reason when the start failed.
export function formatCycleStartCommand(value: unknown): string {
    const command = getCycleStartCommand({ meta: { controller_command: value } });
    if (!command?.status) return "-";
    const text = CYCLE_START_STATUS_TEXT[command.status] || command.status;
    return command.message ? `${text}: ${command.message}` : text;
}

// * Always a string, so it is safe to render: a value that matches no form option comes back
// * as-is from get_form_option_label and can be an array (multi-selects) or an object.
export function toDisplayText(value: unknown): string {
    if (value === null || value === undefined || value === "") return "-";
    if (Array.isArray(value)) return listToString(value);
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}

export function formatHistoryChangeValue(key: string, rawValue: any, getFormOptionLabel: GetFormOptionLabel): string {
    if (rawValue === null || rawValue === undefined || rawValue === "") {
        return "-";
    }
    if (key === "ripening_start_date" || key === "ripening_end_date") {
        return formatDate(rawValue, "DD MMM");
    }
    if (key === "active") {
        return rawValue ? "Yes" : "No";
    }
    if (key === "meta.controller_command") {
        return formatCycleStartCommand(rawValue);
    }
    if (key.startsWith("meta.")) {
        const metaKey = key.replace(/^meta\./, "");
        const value = metaKey === "ripening_program" ? getRipeningProgramDisplayValue(rawValue) : rawValue;
        return toDisplayText(getFormOptionLabel(metaKey, value));
    }
    if (key === "ripening_target" || key === "season") {
        return toDisplayText(getFormOptionLabel(key, rawValue));
    }
    return toDisplayText(rawValue);
}
